// extracted by mini-css-extract-plugin
export default {"modal":"WY-z","modalOverlay":"XY-z","outfitHeading":"YY-z"};